import { AppealsUsersPage } from "./AppealsUsersPage";
import { ComplaintsUsersPage } from "./ComplaintsUsersPage";
import { SuggestionsUserPage } from "./SuggestionsUserPage";
import { UsersPage } from "./UsersPage";
import { UserPage } from "./UserPage";
import { UserAnnouncementsPage } from "./UserAnnouncementsPage";

const pages = {
  AppealsUsersPage,
  ComplaintsUsersPage,
  SuggestionsUserPage,
  UsersPage,
  UserPage,
  UserAnnouncementsPage,
};
export default pages;
